import { type Ref, ref, watch } from 'vue'
import type { ObjectTypesEdgesType } from './types.ts'
import { useLoadObjectTypesEdges } from './api.ts'
import { cloneDeep, keyBy } from 'lodash'

export const useModel = () => {
  const data = ref<ObjectTypesEdgesType[]>([])
  const oldData = ref<{ [key: number]: ObjectTypesEdgesType }>({})

  /**
   * Функция загрузки данных
   * @param fromId
   */
  const loadData = (fromId: Ref<string>) => {
    const result = useLoadObjectTypesEdges(fromId)

    watch(result.data, () => {
      if (result.data.value) {
        data.value = result.data.value.data
        oldData.value = keyBy(cloneDeep(data.value), 'id')
      }
    })

    return result
  }

  return {
    data,
    oldData,

    loadData,
  }
}
